import createCrudService from '@core/api/create-crud-service';

import { QUERY_KEYS } from '@shared/constants/query-keys';
import type { TBaseQuery } from '@shared/types/base-query';
import type { TMember } from '@shared/types/member';

export type TMemberQuery = {
  exclude_interviewers?: boolean;
  is_active?: boolean;
  user?: number | string | (number | string)[];
  type?: 'EMPLOYEE' | 'PARTNER';
} & TBaseQuery;

export type TMemberPayload = {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  avatar?: string;
  role?: number;
};

const memberApi = createCrudService<TMember, TMemberQuery, TMemberPayload>({
  queryKey: [QUERY_KEYS.getMembers],
  url: 'members',
  factory: {
    create: {
      requestOptions: () => {
        return {
          url: 'members/invite/',
        };
      },
    },
  },
  validateQuery: [QUERY_KEYS.getMe],
});

export default memberApi;
